export enum WidgetLayout {
  Mobile,
  Desktop,
  Common,
  None,
}
